module.exports = __webpack_public_path__ + "static/media/Loading_2.5fe4039b.gif";